import React, { useContext } from 'react';
import usePerformanceSlideOutFilterInput from 'components/PerformanceBoards/hooks/usePerformanceSlideOutFilterInput';
import PropertiesSlideoutPreview from './PropertiesSlideoutPreview';
import PerformanceBoardSlideOutContext from 'components/PerformanceBoards/contexts/PerformanceBoardSlideOutContext';
import EditingSectionWrapperDiv from '../EditingSectionWrapperDiv';

const PropertiesContainer = ({
  section,
}: {
  section: PerformanceBoardTypes.SlideOut.PropertiesSection;
}) => {
  const { navState } = useContext(PerformanceBoardSlideOutContext);
  const filterInput = usePerformanceSlideOutFilterInput({
    datasetForDefaultFiltering: section.dataset,
  });

  if (!filterInput) {
    return null;
  }

  if (navState.slideoutMode === 'Creating' || navState.editingSection) {
    return (
      <EditingSectionWrapperDiv>
        <PropertiesSlideoutPreview
          filters={filterInput}
          dataType={section.dataset}
          fields={section.fields}
        />
      </EditingSectionWrapperDiv>
    );
  }

  return (
    <PropertiesSlideoutPreview
      filters={filterInput}
      dataType={section.dataset}
      fields={section.fields}
    />
  );
};

export default PropertiesContainer;
